__turbopack_context__.v({
  "bonusAccruedPanel": "bonus-accrued-panel-module-scss-module__AHZWpG__bonusAccruedPanel",
  "bonusAccruedPanel__count": "bonus-accrued-panel-module-scss-module__AHZWpG__bonusAccruedPanel__count",
  "bonusAccruedPanel__lable": "bonus-accrued-panel-module-scss-module__AHZWpG__bonusAccruedPanel__lable",
});
